import React from 'react'
// components
import ReportContainer from 'containers/Report'

const ReportEditPage: React.FC = () => <ReportContainer />

export default ReportEditPage
